import { create } from 'zustand';

export const useSelectedFieldStore = create((set, get) => ({
  // État initial
  selectedField: {
    transformation_type: 'simple',
    target_field: null,
    lang: 'fr',
    targetFieldEditable: false,
    source_field: null,
    field_mapping: null,
    transformation: null,
    conditions: [],
  },

  // Actions
  setSelectedField: (newSelectedField) =>
    set({ selectedField: newSelectedField }),

  clearSelectedField: () =>
    set({
      selectedField: {
        transformation_type: 'simple',
        target_field: null,
        lang: 'fr',
        targetFieldEditable: false,
        source_field: null,
        field_mapping: null,
        transformation: null,
        conditions: [],
      },
    }),

  getSelectedField: () => get().selectedField,

  isSelectedFieldLoaded: () => get().selectedField !== null,
}));
